import React, { useCallback } from 'react';
import * as XLSX from 'xlsx';
import { PersonData } from '../types';
import './ExcelUploader.css';

interface ExcelUploaderProps {
  onDataLoad: (data: PersonData[]) => void;
}

const ExcelUploader: React.FC<ExcelUploaderProps> = ({ onDataLoad }) => {
  const handleFileUpload = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target?.result as ArrayBuffer);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);

        const processedData: PersonData[] = jsonData.map((row: any) => {
          const item: PersonData = {};
          
          // Add all columns dynamically
          Object.keys(row).forEach(key => {
            item[key] = row[key] || '';
          });
          
          return item;
        }).filter(item => Object.values(item).some(value => value && value.toString().trim()));

        onDataLoad(processedData);
      } catch (error) {
        console.error('Error reading Excel file:', error);
        alert('Greška pri čitanju Excel fajla. Molimo proverite format fajla.');
      }
    };
    reader.readAsArrayBuffer(file);
  }, [onDataLoad]);

  return (
    <div className="excel-uploader">
      <h2>Učitajte Excel fajl</h2>
      <p className="upload-description">
        Excel fajl može da sadrži bilo koje kolone. Posle učitavanja možete da podesite koje kolone se koriste za nalepnice.
      </p>
      
      <div className="upload-area">
        <input
          type="file"
          accept=".xlsx,.xls"
          onChange={handleFileUpload}
          className="file-input"
          id="excel-file"
        />
        <label htmlFor="excel-file" className="file-label">
          <span className="upload-icon">📂</span>
          <span>Kliknite ovde da odaberete Excel fajl</span>
        </label>
      </div>
    </div>
  );
};

export default ExcelUploader; 